import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_PORTAL_LANGUAGE,
  PORTAL_LANGUAGES,
} from "./configs/portalLanguages";
import qr_en from "./translations/qr/en";
import qr_ar from "./translations/qr/ar";
import qr_fr from "./translations/qr/fr";
import qr_es from "./translations/qr/es";

const resources = Object.fromEntries(
  PORTAL_LANGUAGES.map(({ code, translation }) => [code, { translation }]),
);

// QR ordering has its own language choices. Merge namespaces so a language
// can later be used by both the portal and QR pages without another change.
Object.entries({ en: qr_en, ar: qr_ar, fr: qr_fr, es: qr_es }).forEach(
  ([code, qr]) => {
    resources[code] = { ...resources[code], qr };
  },
);

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_PORTAL_LANGUAGE,
  fallbackLng: DEFAULT_PORTAL_LANGUAGE,
  ns: ["translation", "qr"],
  defaultNS: "translation",
  // A missing "qr" key falls back to the portal "translation" namespace,
  // then to English — so a gap degrades gracefully instead of showing the key.
  fallbackNS: "translation",
  debug: false,

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
